/* eslint-disable max-len */
import 'react';

const SideBarSearchClose = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => {
    const id = `${SideBarSearchClose}${Date.now()}`;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="10px" height="10px" viewBox="0 0 10 10" version="1.1">
            <defs>
                <rect id={`path-1${id}`} x="0" y="0" width="10" height="10" />
            </defs>
            <g id="删除" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g xmlns="http://www.w3.org/2000/svg">
                    <mask id={`mask-2${id}`} fill="white">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#path-1${id}`} />
                    </mask>
                    <use id="矩形" fillOpacity="0" fill="#D8D8D8" xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#path-1${id}`} />
                    <path d="M8.37176676,1.17569895 L8.72532015,1.52925234 C8.82295122,1.62688341 8.82295122,1.78517466 8.72532015,1.88280573 L5.71947564,4.88747564 L8.72532015,7.89321337 C8.82295122,7.99084444 8.82295122,8.14913569 8.72532015,8.24676676 L8.37176676,8.60032015 C8.27413569,8.69795122 8.11584444,8.69795122 8.01821337,8.60032015 L5.01247564,5.59447564 L2.00780573,8.60032015 C1.91017466,8.69795122 1.75188341,8.69795122 1.65425234,8.60032015 L1.30069895,8.24676676 C1.20306788,8.14913569 1.20306788,7.99084444 1.30069895,7.89321337 L4.30547564,4.88747564 L1.30069895,1.88280573 C1.20306788,1.78517466 1.20306788,1.62688341 1.30069895,1.52925234 L1.65425234,1.17569895 C1.75188341,1.07806788 1.91017466,1.07806788 2.00780573,1.17569895 L5.01247564,4.18047564 L8.01821337,1.17569895 C8.11584444,1.07806788 8.27413569,1.07806788 8.37176676,1.17569895 Z" id="形状结合" fill="#878D99" mask={`url(#mask-2${id})`} />
                </g>
            </g>
        </svg>
    );
};
export default SideBarSearchClose;
